// register component(s) with react habitat
import withLazyUnveil from '@src/scripts/hoc/withLazyUnveil';

export default {
	DeStipendiumForm: withLazyUnveil( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "DeStipendiumForm" */
				'./index'
			),
		height: 1277,
		mobileHeight: 2858,
	} ),
};
